const AudioIconSVG = ({ className = "" }) => {
  return (
    <svg
      className={className}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4297 5L6.42969 9H2.42969V15H6.42969L11.4297 19V5Z"
        stroke="#fabf1f"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4997 4.93018C21.3744 6.80545 22.4276 9.34853 22.4276 12.0002C22.4276 14.6518 21.3744 17.1949 19.4997 19.0702M15.9697 8.46018C16.9071 9.39781 17.4337 10.6694 17.4337 11.9952C17.4337 13.321 16.9071 14.5925 15.9697 15.5302"
        stroke="#fabf1f"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AudioIconSVG;
